import PriceCardDa from "./da/quotes/price_card";
import PriceCardDe from "./de/quotes/price_card";
import PriceCardEn from "./en/quotes/price_card";
import PriceCardEs from "./es/quotes/price_card";
import PriceCardFi from "./fi/quotes/price_card";
import PriceCardFr from "./fr/quotes/price_card";
import PriceCardIt from "./it/quotes/price_card";
import PriceCardLt from "./lt/quotes/price_card";
import PriceCardLv from "./lv/quotes/price_card";
import PriceCardMe from "./me/quotes/price_card";
import PriceCardNl from "./nl/quotes/price_card";
import PriceCardPl from "./pl/quotes/price_card";
import PriceCardSr from "./sr/quotes/price_card";
import PriceCardSe from "./se/quotes/price_card";
import PriceCardTr from "./tr/quotes/price_card";

export default {
    messages: {
        da:{PriceCard:PriceCardDa},
        de:{PriceCard:PriceCardDe},
        en:{PriceCard:PriceCardEn},
        es:{PriceCard:PriceCardEs},
        fi:{PriceCard:PriceCardFi},
        fr:{PriceCard:PriceCardFr},
        it:{PriceCard:PriceCardIt},
        lt:{PriceCard:PriceCardLt},
        lv:{PriceCard:PriceCardLv},
        me:{PriceCard:PriceCardMe},
        mx:{PriceCard:PriceCardEs},
        nl:{PriceCard:PriceCardNl},
        pl:{PriceCard:PriceCardPl},
        sr:{PriceCard:PriceCardSr},
        se:{PriceCard:PriceCardSe},
        tr:{PriceCard:PriceCardTr},
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/PriceCard.js